import React, { Component } from "react";
import styles from "./logisticReports.module.scss";
import { withLogisticReports } from "../../../shared/containers/containerLogisticReport";
import { states } from "../../../reducers/queriesStates";
import Notification from "../../../shared/items/static/notification";
import LogisticReportsControlPointItem from "./LogisticReportsControlPointItem";
import Scrollbars from "react-custom-scrollbars-2";
import Preloader from "../../../shared/items/static/preloader";

class LogisticReportsControlPoints extends Component {
  render() {
    const { getControlPointsDataState, controlPoints, searchTerm, onSetViewPanel } = this.props;

    const height = window.innerHeight > 800 ? 600 : 400;

    return (
      <div>
        <div className={styles.notificationContainer}>
          {getControlPointsDataState === states.READY && controlPoints.length === 0 ? (
            <Notification type="warning" styles={{ heigth: "40px" }}>
              <p>{`По заданным критериям не найдено данных о контрольных точках`}</p>
            </Notification>
          ) : null}
          {searchTerm === null || searchTerm.length < 4 ? (
            <Notification type="warning" styles={{ heigth: "40px" }}>
              <p>{`Строка адреса должна быть заполнена минимум 4-мя символами`}</p>
            </Notification>
          ) : null}

          {getControlPointsDataState === states.REQUEST ? (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Preloader />
            </div>
          ) : null}
        </div>

        <div className={styles.logisticReportListContainer}>
          <Scrollbars style={{ height: `${height}px` }} autoHide={false} ref="scrollbar">
            {controlPoints.map((controlPoint) => {
              return <LogisticReportsControlPointItem key={controlPoint.id} controlPoint={controlPoint} onSetViewPanel={onSetViewPanel} />;
            })}
          </Scrollbars>
        </div>
      </div>
    );
  }
}

export default withLogisticReports(React.memo(LogisticReportsControlPoints));
